/* eslint-disable default-param-last */
import { get } from 'lodash-es';
import { createSelector } from 'reselect';
import { optionAPI } from '@/api/careClient/option';
var ACTION_TYPES;
(function (ACTION_TYPES) {
    ACTION_TYPES["REMOTE_CONFIG_INIT"] = "remoteConfig/init";
})(ACTION_TYPES || (ACTION_TYPES = {}));
const initialState = {
    hospitalBed: null,
    hospitalData: [],
    symptom: null,
    tube: null,
    servedItem: null,
    careOrderTimeSelection: null,
    careOrderPlan: null,
    marketingChannel: [],
    fee: null,
};
export default function remoteConfigReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.REMOTE_CONFIG_INIT:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
// actions
export const remoteConfigInit = (payload) => ({
    type: ACTION_TYPES.REMOTE_CONFIG_INIT,
    payload,
});
// thunks
export const fetchRemoteConfig = ({ _id, setApiProcessingPool, setApiDonePool, }) => async (dispatch) => {
    const res = await optionAPI.Get({
        _id,
        optionList: [
            'marketingChannel',
            'hospitalData',
            'hospitalBed',
            'symptom',
            'tube',
            'servedItem',
            'careOrderPlan',
            'careOrderTimeSelection',
            'fee',
        ],
    }, setApiProcessingPool, setApiDonePool);
    if (res.success && res.data) {
        dispatch(remoteConfigInit(res.data));
        return { isSuccess: true, errorCode: '' };
    }
    return { isSuccess: false, errorCode: res.errorCode };
};
// selectors
export const selectHospitalList = createSelector((state) => state.remoteConfig.hospitalData, (hospitalData) => hospitalData);
export const selectHospitalBedList = createSelector((state) => state.remoteConfig.hospitalBed, (hospitalBed) => hospitalBed);
export const selectMarketingChannelList = createSelector((state) => state.remoteConfig.marketingChannel, (marketingChannel) => marketingChannel);
export const selectSymptomList = createSelector((state) => state.remoteConfig.symptom, (symptom) => symptom);
export const selectTubeList = createSelector((state) => state.remoteConfig.tube, (tube) => tube);
export const selectServedItemList = createSelector((state) => state.remoteConfig.servedItem, (servedItem) => servedItem);
export const selectMaxServiceDays = createSelector((state) => state.remoteConfig.careOrderTimeSelection, (careOrderTimeSelection) => get(careOrderTimeSelection, 'maxServiceDays'));
export const selectESTBufferHours = createSelector((state) => state.remoteConfig.careOrderTimeSelection, (careOrderTimeSelection) => get(careOrderTimeSelection, 'ESTBufferHours'));
export const selectESTFurthestDays = createSelector((state) => state.remoteConfig.careOrderTimeSelection, (careOrderTimeSelection) => get(careOrderTimeSelection, 'ESTFurthestDays'));
export const selectPartTimeCareOrderPlanList = createSelector((state) => state.remoteConfig.careOrderPlan, (careOrderPlan) => get(careOrderPlan, 'partTime'));
export const selectAllDayPlatformFeePercentage = createSelector((state) => state.remoteConfig.fee, (fee) => {
    const allDayCareOrderConfig = get(fee, 'allDayCareOrder');
    if (!allDayCareOrderConfig)
        return null;
    const allDayPlatformFeePercentage = get(allDayCareOrderConfig, 'platformFeePercentage');
    return allDayPlatformFeePercentage;
});
export const selectPartTimePlatformFeePercentage = createSelector((state) => state.remoteConfig.fee, (fee) => {
    const partTimeCareOrderConfig = get(fee, 'partTimeCareOrder');
    if (!partTimeCareOrderConfig)
        return null;
    const partTimePlatformFeePercentage = get(partTimeCareOrderConfig, 'platformFeePercentage');
    return partTimePlatformFeePercentage;
});
